import { envFlags } from '@thoughtspot/env-flags';
import { getExpiredAccountLifeDays as getExpiredAccountLifeDaysFromSessionService, getTotalTrialDays as getTotalTrialDaysFromSessionService, isHomepageV3Enabled as isHomepageV3EnabledFromSessionService, isModularHomeExperienceEnabled as isModularHomeExperienceEnabledFromSessionService, isNavigationV3Enabled as isNavigationV3EnabledFromSessionService, isOrgsOnFTEnabled as isOrgsOnFTEnabledFromSessionService, isTrialVersionEnabled as isTrialVersionEnabledFromSessionService, } from '@thoughtspot/session-service';
import { getFreeTrialV2ExperienceEnabled, isFreeTrialActivationEnabled as isFreeTrialActivationEnabledFromSessionService, } from '@thoughtspot/system-config-service';
import { getFeatureFlagValues, isFeatureEnabled } from './flags';
import { FEATURE_FLAG_NAMES } from './flags.const';
export const isOrgsOnFTEnabled = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, { key: FEATURE_FLAG_NAMES.ENABLE_ORGS_ON_FREE_TRIAL }, isOrgsOnFTEnabledFromSessionService());
export const isFreeTrialActivationEnabled = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, { key: FEATURE_FLAG_NAMES.FREE_TRIAL_ACTIVATION_ENABLED }, isFreeTrialActivationEnabledFromSessionService());
export const isTrialVersionEnabled = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, {
    key: FEATURE_FLAG_NAMES.TRIAL_VERSION_CONFIG,
    innerKey: 'enableTrialVersion',
}, isTrialVersionEnabledFromSessionService());
export const getExpiredAccountLifeDays = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, {
    key: FEATURE_FLAG_NAMES.TRIAL_VERSION_CONFIG,
    innerKey: 'expiredAccountLifeDays',
}, getExpiredAccountLifeDaysFromSessionService());
export const getTotalTrialDays = () => getFeatureFlagValues({ key: FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_LD_FLAGS }, {
    key: FEATURE_FLAG_NAMES.TRIAL_VERSION_CONFIG,
    innerKey: 'trialAccountLifeDays',
}, getTotalTrialDaysFromSessionService());
export const getIsNavigationV3Enabled = (embedConfig) => {
    if (embedConfig?.isEmbedded) {
        if (embedConfig.embedParams?.navigationVersion === 'v3') {
            return true;
        }
        return false;
    }
    return (isNavigationV3EnabledFromSessionService() &&
        isModularHomeExperienceEnabledFromSessionService());
};
export const isHomepageV3Enabled = (embedConfig) => {
    if (embedConfig?.isEmbedded) {
        if (embedConfig.embedParams?.homepageVersion === 'v3' &&
            embedConfig.embedParams?.navigationVersion === 'v3') {
            return true;
        }
        return false;
    }
    return (getIsNavigationV3Enabled(embedConfig) &&
        isHomepageV3EnabledFromSessionService());
};
export const isFreeTrialV2ExperienceEnabled = () => {
    return (isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_V2_EXPERIENCE, {
        urlParamValue: envFlags.getValue(FEATURE_FLAG_NAMES.ENABLE_FREE_TRIAL_V2_EXPERIENCE),
    }) || getFreeTrialV2ExperienceEnabled());
};
export const getIsEnhancedSerpPage = () => {
    return isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_ADVANCED_SERP);
};
export const getListTablePagesConfig = () => {
    const ldFlagValue = isFeatureEnabled(FEATURE_FLAG_NAMES.ENABLE_LIST_TABLE_PAGES);
    return {
        libraryList: true,
        answerList: true,
        liveboardList: true,
        liveboardSchedules: ldFlagValue?.liveboardSchedules ?? false,
        monitorSubscriptions: ldFlagValue?.monitorSubscriptions ?? false,
    };
};
//# sourceMappingURL=launchdarkly-store.js.map